import PiadaOneApi from './PiadaOneApi';
import MenuCategory from '../classes/MenuCategory';
import Product from '../classes/Product';
import { plainToClass } from 'class-transformer';
import { useUserStore } from '../stores/user';

export default {
  getAll(rid: number): Promise<any> {
    const userStore = useUserStore()

    return new Promise((resolve, reject) => {
      PiadaOneApi.get(
        '/menus/'+rid+'?modless=true',
        {
          // No need for custom headers here
        },
      ).then((response) => {
        let cats = [] as MenuCategory[];
        if (response.status === 200 && response.data) {
          const jsonObjs = response.data['categories'] as MenuCategory[];
          cats = jsonObjs.map(
            (cat) => plainToClass(MenuCategory, (cat as object), { excludeExtraneousValues: true }),
          );
          resolve(cats);
        } else {
          reject(new Error('ERROR'));
        }
      });
    });
  },
  getProduct(rid: number, pid: number): Promise<any> {
    const userStore = useUserStore()

    return new Promise((resolve, reject) => {
      PiadaOneApi.get(
        '/menus/'+rid+'/products/'+pid,
        {
          // No need for custom headers here
        },
      ).then((response) => {
        let cats = [] as MenuCategory[];
        if (response.status === 200 && response.data) {
          const jsonObj = response.data as Product;
          // cats = jsonObjs.map(
          //   (cat) => plainToClass(Product, (cat as object), { excludeExtraneousValues: true }),
          // );
          resolve(jsonObj);
        } else {
          reject(new Error('ERROR'));
        }
      });
    });
  },
  getRecommendations(rid: number, basketid: string): Promise<any> {
    return new Promise((resolve, reject) => {
      let fakeProducts = [] as Product[];
      let img = {position: "product_category", url: "https://www.dobmeierjanitorialsupplies.com/assets/product-images/STERNO-STEST05017.jpg", text_color: null, "text_anchor": null, "image_anchor": null, "overlay_color": null, "overlay_gradient": null};
      let obj = {id: 7843252, chainproductid: 549289, optiongroups: [], name: 'Sterno Can', description: 'Keep your dishes hot!', cost: 2.99, images: [img], quantity: 10}

      fakeProducts.push(plainToClass(Product, (obj as object), { excludeExtraneousValues: true }))
      fakeProducts.push(plainToClass(Product, (obj as object), { excludeExtraneousValues: true }))
      fakeProducts.push(plainToClass(Product, (obj as object), { excludeExtraneousValues: true }))
      fakeProducts.push(plainToClass(Product, (obj as object), { excludeExtraneousValues: true }))
      
      resolve(fakeProducts)
    });
  }
};
